<template>
  <section id="about" class="section bg-white dark:bg-dark-bg relative overflow-hidden">
    <!-- Background Decoration -->
    <div class="absolute top-0 left-0 w-1/3 h-full bg-gradient-to-r from-primary/5 to-transparent pointer-events-none"></div>

    <div class="container-custom relative z-10">
      <!-- Section Header -->
      <div class="text-center mb-16 animate-reveal">
        <h2 class="text-4xl md:text-5xl font-display font-bold text-gray-900 dark:text-white mb-4">
          {{ aboutContent.story.title }}
        </h2>
      </div>

      <!-- Agency Story -->
      <div class="max-w-4xl mx-auto mb-20">
        <div class="space-y-6">
          <p
            v-for="(paragraph, index) in aboutContent.story.paragraphs"
            :key="index"
            class="text-lg md:text-xl text-gray-700 dark:text-gray-300 leading-relaxed text-center story-paragraph"
          >
            {{ paragraph }}
          </p>
        </div>
      </div>

      <!-- Expertise Areas -->
      <div class="mb-20">
        <h3 class="text-3xl md:text-4xl font-display font-bold text-gray-900 dark:text-white text-center mb-12">
          Our Expertise
        </h3>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 stagger-children">
          <ExpertiseCard
            v-for="area in aboutContent.expertiseAreas"
            :key="area.id"
            :icon="area.icon"
            :title="area.title"
            :description="area.description"
          />
        </div>
      </div>

      <!-- Philosophy -->
      <div>
        <h3 class="text-3xl md:text-4xl font-display font-bold text-gray-900 dark:text-white text-center mb-12">
          What Drives Us
        </h3>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 stagger-children">
          <ValueCard
            v-for="value in aboutContent.philosophy"
            :key="value.id"
            :icon="value.icon"
            :title="value.title"
            :description="value.description"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import ExpertiseCard from '@/components/ui/ExpertiseCard.vue';
import ValueCard from '@/components/ui/ValueCard.vue';
import { aboutContent } from '@/data/about.js';
</script>
